import React, { useState } from "react";
import { BaseApi } from "../base.api";
import { useNavigate } from "react-router-dom";
import { Input } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import logo from "../assets/img/glorri.svg"
const Login: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  let navigate = useNavigate();

  const handleLogin = async () => {
    console.log("Email:", email);
    console.log("Password:", password);
    const response = await new BaseApi().postData(
      "user-service-v2/auth/login/admin",
      {
        email,
        password,
      }
    );

    if (response?.status == 201) {
      if (response.data.token && response.data.token.length > 0) {
        localStorage.setItem("token", response.data.token);
        navigate("/main/dashboard");
      }
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.image}></div>
      <div >
        <div style={styles.card}>
          <h2 style={styles.card_title}>Admin Login</h2>
          <label style={styles.label}>Email Address</label>
          <Input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
          />
          <label style={styles.label}>Password</label>

          <Input.Password
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
          />
          <button onClick={handleLogin} style={styles.button}>
            Sign in 
          </button>
        </div>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
    container:{
    display: "flex",
    flexDirection:"column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
  },
  
  card: {
    display: "flex",
    flexDirection: "column",
    padding: "20px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#ffffff",
    width: "370px",
  },
  card_title:{
    display:"flex",
    flexDirection:"column",
    alignItems:"center"
  },
  title: {
    marginBottom: "20px",
    fontSize: "24px",
    fontWeight: "bold",
    color: "#333",
  },
  
  input: {
    width: "100%",
    padding: "10px",
    marginBottom: "15px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    fontSize: "16px",
  },
  button: {
    width: "100%",
    padding: "10px",
    backgroundColor: "#007BFF",
    color: "#ffffff",
    border: "none",
    borderRadius: "5px",
    fontSize: "16px",
    cursor: "pointer",
  },
  image:{
    backgroundImage:`url(${logo})`,
    backgroundRepeat:"no-repeat",
    width:"83px",
    height:"42px",
    marginBottom:"12px",
    backgroundSize:"contain"
  },
  label:{
    marginBottom:"12px"
  }
};

export default Login;
